import _ from 'lodash';
import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { IRootState } from 'stores/rematch/root-store';
import { Group, ScrollArea, Tabs } from '@good/ui/core';
import { BookingViewTabsTab } from './booking-view-tabs-tab';
import { CustomViewsModalType } from 'utilities/enum-utils';
import { useChangeView } from 'views/bookings-v2/books-view-context/use-change-view';

interface BookingViewTabsProps {
  openBookingViewModal: (type: CustomViewsModalType) => void;
}

export const BookingViewTabs = ({ openBookingViewModal }: BookingViewTabsProps) => {
  const bookingListingActiveTab = useSelector((state: IRootState) => state.bookingsStore.bookingListingActiveTab);
  const defaultBookingViews = useSelector((state: IRootState) => state.bookingsStore.defaultBookingViews);
  const displayedBookingListingTabs = useSelector(
    (state: IRootState) => state.bookingsStore.displayedBookingListingTabs,
  );
  const isBookingListingLoading = useSelector((state: IRootState) => state.bookingsStore.isBookingListingLoading);
  const changeView = useChangeView();

  const changeTab = useCallback(
    async (selectedTabId: string | null) => {
      const activeTab = [...defaultBookingViews, ...displayedBookingListingTabs].find(
        (tab) => tab.customViewId === selectedTabId,
      );

      changeView(activeTab, [...defaultBookingViews, ...displayedBookingListingTabs], {
        reset: true,
        caller: 'BookingViewTabs.changeTab',
      });
    },
    [changeView, defaultBookingViews, displayedBookingListingTabs],
  );

  return (
    <Tabs
      variant='outline'
      mb={-1}
      defaultValue='ALL'
      value={_.get(bookingListingActiveTab, 'customViewId') ?? 'ALL'}
      onChange={changeTab}
      styles={{
        list: {
          flexWrap: 'nowrap',
        },
      }}
    >
      <Group justify='space-between' align='center' wrap='nowrap'>
        <ScrollArea scrollbars='x'>
          <Tabs.List>
            {defaultBookingViews.map((tab) => (
              <BookingViewTabsTab
                key={tab.customViewId}
                tab={tab}
                disabled={isBookingListingLoading}
                selected={bookingListingActiveTab.customViewId === tab.customViewId}
              />
            ))}
            {displayedBookingListingTabs.map((tab) => (
              <BookingViewTabsTab
                key={tab.customViewId}
                tab={tab}
                disabled={isBookingListingLoading}
                custom
                openBookingViewModal={openBookingViewModal}
                selected={bookingListingActiveTab.customViewId === tab.customViewId}
              />
            ))}
          </Tabs.List>
        </ScrollArea>
      </Group>
    </Tabs>
  );
};
